<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="pb-12 lg:pb-20">
        <div class="relative z-0">
            <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div
                    class="relative lg:grid lg:grid-cols-7"
                    :style="{ 'grid-template-rows': '40px auto 40px' }"
                >
                    <LoopCard
                        v-for="(variant, index) in variants.slice(0, 3)"
                        :key="variant.id"
                        :index="index"
                        :pricing="pricing"
                        :variant="variant"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoopCard from "./LoopCard.vue";

export default {
    name: "LoopLayout",
    components: {
        LoopCard,
    },
    props: {
        pricing: Object,
        variants: Array,
    },
};
</script>
